//herActions.ts
import { Batch, Notification, NotificationDetail } from "store/dataReducers/HERReducer";

export const HER_ACTIONS_TYPES = {
  SET_BATCHES: "SET_BATCHES",
  SET_BATCH_NOTIFICATIONS: "SET_BATCH_NOTIFICATIONS",
  SET_NOTIFICATION_DETAIL: "SET_NOTIFICATION_DETAIL",
  REMOVE_BATCH: "REMOVE_BATCH",
  // Separate loading states
  SET_BATCHES_LOADING: "SET_BATCHES_LOADING",
  SET_NOTIFICATIONS_LOADING: "SET_NOTIFICATIONS_LOADING",
  // Separate error states
  SET_BATCHES_ERROR: "SET_BATCHES_ERROR",
  SET_NOTIFICATIONS_ERROR: "SET_NOTIFICATIONS_ERROR",
  CLEAR_BATCHES_ERROR: "CLEAR_BATCHES_ERROR",
  CLEAR_NOTIFICATIONS_ERROR: "CLEAR_NOTIFICATIONS_ERROR",
};

export const HER_ACTIONS = {
  SET_BATCHES: (payload: Batch[]) => {
    return {
      type: HER_ACTIONS_TYPES.SET_BATCHES,
      payload,
    };
  },
  SET_BATCH_NOTIFICATIONS: (batchId: string, notifications: Notification[], totalCount: number) => {
    return {
      type: HER_ACTIONS_TYPES.SET_BATCH_NOTIFICATIONS,
      batchId,
      notifications,
      totalCount,
    };
  },
  SET_NOTIFICATION_DETAIL: (notificationId: string, detail: NotificationDetail) => {
    return {
      type: HER_ACTIONS_TYPES.SET_NOTIFICATION_DETAIL,
      payload: {
        notificationId,
        detail,
      },
    };
  },
  REMOVE_BATCH: (batchId: string) => {
    return {
      type: HER_ACTIONS_TYPES.REMOVE_BATCH,
      payload: batchId,
    };
  },
  // Batches loading actions
  SET_BATCHES_LOADING: (isLoading: boolean) => {
    return {
      type: HER_ACTIONS_TYPES.SET_BATCHES_LOADING,
      payload: isLoading,
    };
  },
  // Notifications loading actions
  SET_NOTIFICATIONS_LOADING: (isLoading: boolean) => {
    return {
      type: HER_ACTIONS_TYPES.SET_NOTIFICATIONS_LOADING,
      payload: isLoading,
    };
  },
  // Batches error actions
  SET_BATCHES_ERROR: (error: string) => {
    return {
      type: HER_ACTIONS_TYPES.SET_BATCHES_ERROR,
      payload: error,
    };
  },
  CLEAR_BATCHES_ERROR: () => {
    return {
      type: HER_ACTIONS_TYPES.CLEAR_BATCHES_ERROR,
    };
  },
  // Notifications error actions
  SET_NOTIFICATIONS_ERROR: (error: string) => {
    return {
      type: HER_ACTIONS_TYPES.SET_NOTIFICATIONS_ERROR,
      payload: error,
    };
  },
  CLEAR_NOTIFICATIONS_ERROR: () => {
    return {
      type: HER_ACTIONS_TYPES.CLEAR_NOTIFICATIONS_ERROR,
    };
  },
};

